import { normalize, schema } from "normalizr";

const messageSchema = new schema.Entity("messages", {}, { idAttribute: "_id" });

export const normalizeMessageData = messagesData =>
	normalize(messagesData, { messages: [messageSchema] });